module.exports = __webpack_public_path__ + "static/media/piper-dialog4-desktop-es.bc64b67b.svg";